import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
const baseUrl = process.env.REACT_APP_BASE_URL
const config = {
    headers: {
        "Content-Type": "application/json",
    }
}

const initialState = {
    authLoading: false,
    authSuccess: false,
    authError: false,
    authMessage: null,
    authData: null
}

export const authenticateUser = createAsyncThunk("authenticateUser", async (body) => {
    const { path, data } = body;
    const url = baseUrl + path

    return await axios.post(url, data, config).then((response) => {
        return response
    }).catch((error) => { return error })
})

const AuthSlice = createSlice({
    name: "auth",
    initialState,

    reducers: {
        resetAuthState: (state) => {
            state.authLoading = false
            state.authSuccess = false
            state.authError = false
            state.authMessage = false
        }
    },

    extraReducers: (builder) => {
        builder.addCase(authenticateUser.pending, (state) => {
            state.authLoading = true;
            state.authSuccess = false;
            state.authError = false;
            state.authMessage = null;
            state.authData = null;
        })
        builder.addCase(authenticateUser.fulfilled, (state, action) => {
            const status = action.payload.data?.status != undefined ? action.payload.data.status : false
            state.authLoading = false;
            state.authSuccess = status == true || status == "true" ? true : false;
            state.authError = status == true || status == "true" ? false : true;
            state.authMessage = status == true || status == "true" ? "You are loged in successfully." : null;
            state.authData = status == true || status == "true" ? action.payload.data.data : null;
        })
        builder.addCase(authenticateUser.rejected, (state, action) => {
            state.authLoading = false;
            state.authSuccess =  false;
            state.authError =  true;
            state.authMessage = "Something is went wrong.";
            state.authData = null;
        })
    }
})

export const { resetAuthState } = AuthSlice.actions;
export default AuthSlice.reducer;